import React from 'react';
import AdminLayout from '../../Hoc/AdminLayout';
import SimpleMap from '../home/googlemap';
const Dashboard = () => {
    return (
        <AdminLayout>
            <SimpleMap/>
        </AdminLayout>
         
    );
};

export default Dashboard;


// WEBPACK FOOTER //
// ./src/Components/admin/Dashboard.js